export const room_types = {
  1: {
    label: "Appartamento"
  },
  4: {
    label: "Quadrupla"
  },
  5: {
    label: "Suite"
  },
  7: {
    label: "Tripla"
  },
  8: {
    label: "Doppia con Letti Singoli"
  },
  9: {
    label: "Matrimoniale"
  },
  10: {
    label: "Singola"
  },
  12: {
    label: "Monolocale"
  },
  13: {
    label: "Familiare"
  },
  20: {
    label: "Sconosciuto"
  },
  23: {
    label: "Doppia Uso Singola"
  },
  24: {
    label: "Matrimoniale/Doppia con Letti Singoli"
  },
  25: {
    label: "Dormitorio"
  },
  26: {
    label: "Posto Letto in Dormitorio"
  },
  27: {
    label: "Bungalow"
  },
  28: {
    label: "Chalet"
  },
  29: {
    label: "Casa Vacanze"
  },
  31: {
    label: "Villa"
  },
  32: {
    label: "Casa Mobile"
  },
  33: {
    label: "Tenda"
  },
  35: {
    label: "Piazzola"
  },
  36: {
    label: "Offerta da Sito Partner"
  },
  37: {
    label: "Camera Privata con 5 Letti"
  },
  38: {
    label: "Camera Privata con 6 Letti"
  },
  39: {
    label: "Camera Privata Grande"
  }
}

export function get_room_types(key) {
  if (room_types[key] !== undefined) return room_types[key]
}